<template>
	<div class="registration-success-container">
		<h2>Your request has been sent successfully.</h2>
		<p>The DRC Team will create log in credentials for you and you will receive an email confirmation with your Guest account details.</p>
		<button @click="() => $router.push('/sign-in')">GO BACK TO LOGIN</button>
	</div>
</template>

<script>
export default {
	name: "SuccessRegistration",
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.registration-success-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 100%;
	gap: 20px;

	@media (max-width: $tablet) {
		width: 100%;
		max-width: 480px;
		height: unset;
		padding: 0;
		margin: unset;
		gap: 30px;
	}

	h2 {
		font-family: Tiempos Headline, serif;
		font-size: 28px;
		font-weight: 500;
		line-height: 34px;
		letter-spacing: 0.36px;
		text-align: left;
		margin: 0;
	}

	p {
		font-family: Roboto, serif;
		font-size: 17px;
		font-weight: 400;
		line-height: 22px;
		text-align: left;
		margin: 0;
	}

	button {
		width: 100%;
		background-color: $color-hover-button;
		min-height: 48px;
		padding: 10px 18px;
		gap: 12px;
		font-family: Roboto, serif;
		font-size: 17px;
		font-weight: 400;
		line-height: 22px;
		text-align: center;
		cursor: pointer;
		margin-top: 20px;
		margin-bottom: 20px;
		text-transform: uppercase;
		border: none;
	}
}
</style>
